export const types = {
  CLOSE: 'common/drawers/createEditActionDefinitionDrawer/CLOSE',
  OPEN: 'common/drawers/createEditActionDefinitionDrawer/OPEN',
};

export const createEditActionDefinitionDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  open: ({ managedIntegrationUuid, actionDefinitionUuid, isEditing }) => ({
    type: types.OPEN,
    payload: {
      managedIntegrationUuid,
      actionDefinitionUuid,
      isEditing,
    },
  }),
};
